"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const filter_1 = __importDefault(require("lodash/filter"));
const get_1 = __importDefault(require("lodash/get"));
const keyBy_1 = __importDefault(require("lodash/keyBy"));
const mapValues_1 = __importDefault(require("lodash/mapValues"));
const formatTime_1 = __importDefault(require("../formatTime"));
const getDayNumber_1 = __importDefault(require("../getDayNumber"));
/**
 * Returns on/open days hashmap for a branch
 * @param {Array} timings
 * @returns {object}
 */
const getOnDays = (timings) => {
    const filteredOnDays = (0, filter_1.default)(timings, 'open');
    const timingHashMap = (0, keyBy_1.default)(filteredOnDays, (item) => (0, getDayNumber_1.default)((0, get_1.default)(item, 'day')));
    return (0, mapValues_1.default)(timingHashMap, (item) => {
        const timeRanges = (0, get_1.default)(item, 'timeRanges', []);
        const startWorkingHour = (0, get_1.default)(timeRanges[0], 'start');
        const lastWorkingHour = (0, get_1.default)(timeRanges[timeRanges.length - 1], 'end');
        const start = startWorkingHour || (0, get_1.default)(item, 'start');
        const end = lastWorkingHour || (0, get_1.default)(item, 'end');
        const isMultiTimeSlot = timeRanges.length > 1;
        const is24hr = !isMultiTimeSlot &&
            timeRanges.length > 0 &&
            startWorkingHour === lastWorkingHour;
        return {
            start: (0, formatTime_1.default)(start),
            end: (0, formatTime_1.default)(end),
            start24: start,
            end24: end,
            day: (0, get_1.default)(item, 'day').toLowerCase(),
            is24hr,
            isMultiTimeSlot,
        };
    });
};
exports.default = getOnDays;
